<style>
    h1, h2, h3, h4 {
    font-weight: 300;
  }

  h1, h2 {
    margin-top: 8px;
  }

  h6 {
    font-weight: 500;
    font-size: 14px;
    margin-top:4px;
    margin-bottom: 0;
  }

  .highlight {
    background-color: #EEF8FF;
    display: inline-block;
    padding: 0 4px;
  }

  #breed-card {
    opacity: 0;
    z-index: 10;
    display: none;
    grid-template-columns: 1fr;
    width: 100%;
    max-width: 500px;
    padding: 0;
    background-color: white;
    border: 1px solid rgba(209, 213, 219, 0.5);
    backdrop-filter: blur(8px) saturate(180%);
    -webkit-backdrop-filter: blur(8px) saturate(180%);
    background-color: rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 500ms;
  }

  #breed-card.open {
    opacity: 1;
    display: grid;
    transform: translateY(0px);
  }

  #breed-card > div {
    padding: 32px 24px;
  }

  .intro {
    background-color: #F9F0E6;
  }

  .intro .header {
    display: grid;
    grid-template-columns: 1fr auto;
    justify-content: space-between;
  }

  #close {
    text-align: right;
    font-size: 24px;
    cursor: pointer;
    color: #ccc;
  }

  .intro img {
    width: 100%;
    height: auto;
  }

  .facts {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    text-align: center;
  }

  .button {
    display: inline-block;
    text-align: center;
    background: #0F6BFF;
    padding: 20px 0;
    width: 100%;
    margin: 20px auto;
    border-radius: 32px;
    text-decoration: none;
    color: white;
    transition: background .25s;
  }

  .button:hover {
    background: #123C9D;
  }

  .activity {
    background: #B5D5FF;
  }

  .activity #minutes {
    font-size: 48px;
  }

  .whistle {
    height: 16px;
    margin-left: 4px;
  }

  .articles {
    padding: 32px 0 20px !important;
    background: white;
    margin: 36px 8px 16px;
    border-radius: 8px;
  }

  .articles-header {
    margin: 0 24px 24px;
  }

  .article-feed {
    display: grid;
    grid-template-columns: 1fr;
    border-top: #F9F9F9 solid 2px;
  }

  .article {
    display: grid;
    grid-template-columns: 80px auto auto;
    grid-gap: 16px;
    align-items: center;
    border-bottom:solid #F9F9F9 2px;
    color: #101011;
    padding: 16px;
    text-decoration: none;
  }

  .article:hover {
    background: #F9F9F9;
  }

  .article img {
    height: 80px;
    width: 80px;
    object-fit: cover;
    border-radius: 50%;
  }

  .article h6 {
    margin:0;
    font-weight: 400;
    font-size: 16px;
  }

  .wildest {
    height: 24px;
    margin-left: 8px;
  }

  .chevron {
    height:48px;
    justify-self: flex-end;
  }

  .cta {
    color: #101011;
    text-decoration: none;
    font-size: 12px;
    display: grid;
    grid-template-columns: auto 1fr;
    place-content: center;
  }

  .articles .cta {
    grid-template-columns: auto auto auto;
    margin: 20px auto 0;
  }

  .articles .cta p {
      margin: 8px 0;
  }

  .caret {
    justify-self: flex-start;
    height: 24px;
    fill: var(--color-wet-nose);
    margin-top: 4px;
  }

  .adopt {
    padding: 32px 0 52px !important;
    margin-top: 24px;
    overflow-x: hidden;
    background: var(--color-pink-sand);
    background: linear-gradient(
      0deg,
      var(--color-pink-sand) 0%,
      var(--color-pink-sand) 50%,
      var(--color-cinammon) 50%,
      var(--color-cinammon) 100%
    );
    height: 560px;/* Had to add this to fix a weird Firefox bug (the bg wasn't reaching all the way to the end).*/
  }

  .adopt-header {
    margin: 0 24px 24px;
    color: white;
  }

  .adoptable-feed {
    position: relative;
    display: grid;
    padding-right: 24px;
    grid-template-columns: repeat(6, 1fr);
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }

  .adoptable-feed::-webkit-scrollbar {
    display: none;
  }

  .adoptable-feed h2 {
    color:#101011;
    margin-top: 20px;
    margin-bottom: 4px;
  }

  .dog-card, .adopt-card {
    text-align: center;
    white-space: normal;
    width: 200px;
    border-radius: 4px;
    padding: 40px 40px 28px;
    margin-left: 16px;
    background-color: white;
    color:#101011;
    text-decoration: none;
  }

  .dog-card img {
    width: 100%;
    border-radius: 50%;
  }

  .adopt-card img {
    margin-top: 8px;
  }

  @media (min-width:400px) {

      #breed-card {
        overflow: hidden;
        margin: 1em 1.5em;
        border-radius: 12px;
        transform: translateY(40px);
        height: 80vh;
        overflow-y: scroll;
        position: absolute; 
        top: 0;
        bottom: 0;
        left: 0; 
        right: 0; 
        margin: auto; 
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
      }

      #breed-card::-webkit-scrollbar {
            display: none;
      }
  }
</style>

<script lang="ts">
  export let open: boolean = false;
  $: openClass = (open) ? 'open' : 'closed';
</script>

<div id="breed-card" class="{openClass}">
      
    <div class="intro">
      <div class="header">
        <div>
          <h6>Asian and Oceanian breed</h6>  
          <h1>Siberian Husky</h1>  
        </div>
        <div id="close">&#10005;</div>
      </div>
    
    <img src="https://breed-assets.wisdompanel.com/dog/siberian-husky/Siberian_Husky_Color_Small_File.png" />
    
  </div>
  <div>
    <div class="facts">
      <div class="metrics">
        <h6>Weight</h6>
        <p>34–67 lb</p>
      </div>
      <div class="metrics">
        <h6>Height</h6>
        <p>21–23 in</p>
      </div>
        <div class="metrics">
        <h6>Lifespan</h6>
        <p>12–15 yr</p>
      </div>
    </div>
    
    <div class="about">
      <p> The Siberian Husky is a very intelligent breed that's active, alert, and gentle. Their love of people and demeanor around children make these pups wonderful pets and companions. </p>
      <a class="button" href="https://www.wisdompanel.com/en-us/dog-breeds/siberian-husky" target="_blank">Get More Breed Facts</a>
    </div>
  </div>
    <div class="activity">
      <h6>Activity requirements</h6>
      <h2>This is a <span class="highlight">high-energy</span> breed that needs an average of</h2>
      <span id="minutes"><span id="number">61</span> minutes</span>
      <h2>of daily activity.</h2>
      <!-- Young: 92 minutes daily
      Adult: 55 minutes daily
      Senior: 37 minutes daily  
      avg: 61-->
      <a class="cta" href="https://www.whistle.com" target="_blank">Insights powered by 
        <svg class="whistle" viewbox="0 0 134 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.5619 24C33.2221 24 38.5924 18.6171 38.5924 12C38.5924 5.35667 33.1957 0 26.5619 0H0V10.477H3.02737C11.9252 10.4508 15.3211 24 26.5619 24ZM26.5619 21.0591C17.4534 21.0591 14.5314 7.45733 3.02737 7.45733V2.94092H18.4275V8.95405C19.3225 5.9081 22.2709 2.8884 26.5619 2.8884C31.6426 2.8884 35.6703 6.90591 35.6703 12C35.6703 17.0678 31.6426 21.0591 26.5619 21.0591Z" fill="#94C83D"></path>
          <path d="M85.1084 21.2955V7.4574H82.0811V21.2955H85.1084Z" fill="#323335"></path>
          <path d="M113.487 21.2953V2.62573H110.486V21.2953H113.487Z" fill="#323335"></path>
          <path d="M61.0474 21.2953L66.0755 2.62573H62.8638L59.4153 17.199L56.4669 2.62573H52.6498L49.6487 17.2253L46.2265 2.62573H42.9885L48.0429 21.2953H51.4388L54.5715 6.22311L57.7305 21.2953H61.0474Z" fill="#323335"></path>
          <path d="M99.2976 11.0547C98.7448 8.71773 96.4545 7.22101 93.5325 7.16849C89.5837 7.11597 87.8726 9.40044 87.8463 11.4486C87.82 12.919 88.636 13.9956 90.1102 14.5733C92.1372 15.3611 94.9803 15.4136 96.1123 16.2801C97.0337 16.9891 96.5862 18.0919 95.7174 18.512C94.5065 19.116 91.5844 19.326 90.4261 17.0678H87.2935C87.82 19.7199 90.2682 21.453 93.5851 21.5055C97.06 21.558 99.5082 19.7462 99.5609 17.1204C99.5872 14.4945 97.5865 13.6543 94.7697 13.1028C93.0849 12.7877 91.8214 12.814 91.3475 12.3151C90.742 11.7112 90.5314 10.6608 91.8214 10.1094C93.2429 9.50547 95.7438 9.79431 96.0333 11.0547H99.2976Z" fill="#323335"></path>
          <path d="M122.227 7.19482C118.383 7.19482 115.277 10.5034 115.277 14.4421C115.277 18.3283 118.383 21.5056 122.227 21.5056C125.333 21.5056 127.729 19.9301 128.65 17.0942H125.359C124.727 18.302 123.543 18.906 122.2 18.906C120.384 18.906 118.804 17.8031 118.278 15.5712H129.097C129.282 13.0241 128.597 10.9235 127.228 9.42677C125.991 8.06135 124.227 7.19482 122.227 7.19482ZM118.304 13.1554C118.304 12.5778 119.147 9.82065 122.2 9.82065C125.28 9.82065 126.149 12.394 126.149 13.1554H118.304Z" fill="#323335"></path>
          <path d="M102.325 10.162V15.5186C102.43 19.0635 104.326 21.2954 107.537 21.2954C107.748 21.2954 107.958 21.2954 108.037 21.2692V18.302C106.274 18.302 105.431 17.488 105.326 15.5449V10.162H108.037V7.45737H105.326V3.83374H102.299V7.45737H100.798V10.162H102.325Z" fill="#323335"></path>
          <path d="M79.6855 21.2953V13.234C79.6855 9.5579 77.6848 7.32595 74.4205 7.32595C72.2881 7.32595 70.8929 8.71764 70.8929 8.71764V2.62573H67.9182V21.2953H70.9456V13.234C70.8929 11.4747 72.1302 10.2669 73.9203 10.2669C76.6318 10.2669 76.7107 12.5513 76.6844 13.234V21.2953H79.6855Z" fill="#323335"></path>
          <path d="M85.3981 4.12259C85.3981 5.12041 84.582 5.90815 83.608 5.90815C82.6339 5.90815 81.8179 5.09415 81.8179 4.12259C81.8179 3.15104 82.6339 2.33704 83.608 2.33704C84.582 2.33704 85.3981 3.15104 85.3981 4.12259Z" fill="#323335"></path>
          <path d="M129.94 9.63668V7.53602H129.203V7.27344H130.993V7.53602H130.256V9.63668H129.94Z" fill="#323335"></path>
          <path d="M133.414 9.63668V7.69357L132.598 9.63668H132.467L131.677 7.69357V9.63668H131.387V7.27344H131.809L132.546 9.059L133.283 7.27344H133.704V9.63668H133.414Z" fill="#323335"></path>
          </svg>
        </a>
    </div>
    
    <div class="articles">
      <div class="articles-header">
        <h6>Recommended reading</h6>
        <h2>Check out the latest articles about Siberian Huskies.</h2>
      </div>
      
      <div class="article-feed">
        
        <a class="article" href="https://thewildest.com/dog-behavior/easiest-dogs-to-train" target="_blank">
            <img src="https://images.ctfassets.net/sfnkq8lmu5d7/1zfLQVnIbKDvkf5fw2RwPL/3c909635dbde8285f0dff24de8416bf1/2021_0623_EasiestDogBreedsToTrain_Hero_1000x750__1_.jpg" />
            <h6>Top 10 Easiest Dogs to Train</h6>
            <svg class="chevron" viewBox="0 0 24 24">
                <path d="M14.586 12l-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293z"></path>
            </svg>
        </a> 

        <a class="article" href="https://thewildest.com/dog-lifestyle/the-perfect-dog-breed-for-every-star-sign" target="_blank">
            <img src="https://images.ctfassets.net/sfnkq8lmu5d7/6kqfTjwlQR55MXv9ED5bIt/91d12eef210a8c8aa1af0fa04557ec22/2021_0517-dogForStarSign.jpg" />
            <h6>The Perfect Dog Breed for Every Star Sign</h6>
            <svg class="chevron" viewBox="0 0 24 24">
              <path d="M14.586 12l-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293z"></path>
            </svg>
        </a>

        <a class="article" href="https://thewildest.com/dog-lifestyle/doggie-daycare" target="_blank">
            <img src="https://images.ctfassets.net/sfnkq8lmu5d7/2UXq5S4QPNXJkfNUWbQkoe/5da88211915e0e08f098b9f814f6acf0/2021_03-howToFindDoggieDaycare-Stocksy_txpafa94d52B92300_Medium_1380365.jpg" />
            <h6>Working Pet Parent? Doggie Daycare to the Rescue!</h6>
            <svg class="chevron" viewBox="0 0 24 24">
              <path d="M14.586 12l-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l6-6c0.391-0.391 0.391-1.024 0-1.414l-6-6c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l5.293 5.293z"></path>
            </svg>
         </a>

      </div>
      <a class="cta" href="https://thewildest.com/" target="_blank">
        <p >See more articles from</p>
        <svg class="wildest" xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 1518 354"><path d="M706.8 2.5c-31.2 7.9-47.7 41.3-35.3 71.6 6.2 15.4 18.2 28.7 48 53.1 23.9 19.6 34.5 29.1 43.6 39.3 13.4 15 22.1 30.2 27.6 48 2.6 8.6 2.7 10 2.7 29.5s-.2 20.9-2.8 29.5c-7.1 23.3-19.1 36.3-37.9 41.1-12.6 3.3-27-.2-35.6-8.5-9-8.8-12.7-19.7-11.8-35.1.5-9.8 2.2-15.7 13.7-48.3 12.8-36.2 10.1-63.3-8.1-80.1-11-10.2-23.8-14-39.2-11.8-22.3 3.2-38.4 19.1-45.9 45.2-2 6.9-2.2 10-2.3 41-.2 19.9-.7 36.7-1.4 41.5-3.6 24.1-11.4 39.6-22.7 45.1-4.6 2.3-6.3 2.6-11 2.1-18.5-1.9-27.1-21.9-23.5-54.9 5.1-46.9 33-100.5 75.4-144.4 5.3-5.6 9.7-10.6 9.7-11.2 0-.6-.9-2.6-2-4.5l-2-3.4-9.8 2.4c-15.2 3.8-29.1 4-49.7 1-40.3-6-57.2-4.1-74 8.6-33.4 25.2-24.8 81.7 12.4 81.7 13.1 0 21.5-6.4 24-18.2 4.6-21.4-19.1-37-36.1-23.7-4.2 3.3-5.1 2.7-4.2-3 1.5-9.6 9.7-16.9 20.4-18.5 6.4-.9 21.6.9 37.5 4.4 7.5 1.7 17 3.3 21.1 3.7 4.1.3 7.4.9 7.4 1.3 0 .3-1.5 2.4-3.3 4.6-8.5 9.8-22.8 29.2-31.6 42.4-22.1 33.3-33.6 62.9-36 92.2-3.7 44.9 16.7 73.9 53.7 76.4 33.9 2.4 56.1-19 65.5-63.1 2-9.2 2.2-13.1 2.2-50 .1-42 .3-45 4.8-54 4.1-8.5 9.8-12.5 17.7-12.5 12 0 18.4 8.3 18.3 24-.1 10.9-1.8 17.1-10.3 37.4-12.1 29.1-14.6 39.6-13.8 59.8.4 9.8 1.1 13.9 3.2 20.3 7.5 22.3 25.4 38.9 49.2 45.7 11.5 3.3 34.4 3.3 45.7 0 34.2-9.9 57.4-37.8 64.3-77.3 2-11.4 1.4-38.4-1.1-49.4-8.5-38.1-27.4-64.6-74-103.9-32.4-27.3-41.3-36.3-46.6-47.3-10.6-22.1 2.9-38.2 23.8-28.4 11.5 5.5 20.5 16.5 43.4 53.4 18.9 30.6 32.9 46.9 47.5 55.5 10.7 6.3 16.1 7.7 29.4 7.7 9.9 0 12.2-.3 16.5-2.3 12.1-5.6 20-14.3 23.6-26.4 2.7-8.9 2.4-21.9-.8-28.9C881.4 92 872.6 86 861.5 86c-14.4 0-24.6 10.1-24.7 24.4 0 8.1 2.4 13.7 8 18.6 4.2 3.7 11.9 7 16.4 7 2.5 0 2.3 1.2-.9 4.2-8.1 7.7-21.8 4.8-32-6.7-7.1-7.9-12.1-17.3-25.5-47.4-18-40.2-25.3-52.8-38.7-66.2-8.1-8-15.2-12.6-24.8-16-7.7-2.7-24.5-3.5-32.5-1.4zM179.7 90.8l-22.8 8.7.3 4.9.3 4.8 9 3.3 9 3.2.3 91.9c.1 53.8-.2 95.5-.7 100.6-1.5 13.7-4.8 18.2-14.8 20.3-3.3.7-3.3.7-3.3 6.6v5.9h76.1l-.3-6.1-.3-6.2-5-1.2c-5.7-1.5-9.7-5.4-11.6-11.2-.9-2.7-1.4-18-1.6-54.4l-.4-50.7 4.7-3.6c16.7-12.8 37.9-14.9 45.6-4.5 5.2 7 5.2 7.4 5.6 55.1.2 25.2-.1 47.8-.6 51.7-1.7 12.2-5.5 17.1-14.3 18.5l-3.9.6v12h76v-11.8l-5-1.2c-6.2-1.5-10.3-5.3-12-11.2-.9-3.1-1.5-19.1-2-58.8-.5-39.6-1-55.6-1.9-58.5-3.9-12.1-11.7-21.5-21.9-26.3-5.3-2.5-6.6-2.7-19.2-2.7-12.1 0-14.3.3-20.8 2.7-8.6 3.1-16 7.4-24.3 14.1l-5.9 4.8V82l-5.7.1c-4.8 0-9.8 1.5-28.6 8.7z"/><path d="M926.8 90.8L904 99.5v9.3l8.6 3.1c4.7 1.7 8.9 3.1 9.5 3.1 1.3 0 1.2 191-.1 198.1-2.3 11.8-6.8 15.9-17.6 15.9s-15.6-5.2-17.4-19.1c-.5-4.1-1-37.2-1-73.7V170h-5.2c-4.2 0-10 1.7-28.5 8.7l-23.3 8.8v9.3l9.5 3.3 9.5 3.4V253c0 27.2-.5 52.8-1 56.7-1.6 12.3-5.1 16.7-14.7 18.8-3.3.7-3.3.7-3.3 6.6v5.9l75.8-.2 75.7-.3.3-5.7c.3-5.6.2-5.8-2.5-6.4-9.9-2.2-12.7-4.5-15.1-12.6-1.4-4.7-1.7-19.1-2-119.6L960.9 82l-5.7.1c-4.6 0-9.9 1.7-28.4 8.7zm162 0l-22.8 8.7v9.3l8.6 3.1c4.7 1.7 8.9 3.1 9.5 3.1.5 0 .9 12.9.9 33.1v33l-2.7-1.9a59.7 59.7 0 00-16.8-7.8c-6.7-1.8-21.7-1.8-29 .1-27.9 7.3-47.8 37.6-51.5 78.7-4.4 48.1 18.1 88.2 52.3 93.1 14.1 2 29.5-2.8 42.7-13.4l6-4.9v19h4.8c3.3 0 11.3-2.3 27.2-7.8l22.5-7.9.3-5 .3-5-4.1-.6c-8.7-1.1-11.8-5.6-13.1-19.1-.4-5-.9-55.8-.9-112.9V82l-5.7.1c-4.7 0-10 1.6-28.5 8.7zm-20.5 98.4c5.8 2.5 10.9 8.3 13.9 15.7 2.3 5.5 2.3 6.4 2.6 53.7l.3 48.2-4 3.1c-8.9 7.1-21.7 9.6-30.2 5.9-16.5-7.1-25.1-30.6-25.3-69.3-.1-20.5 1.3-29 6.9-41.2 7.7-16.8 20.6-22.6 35.8-16.1zM1 123.5V154h11.6l2.7-9.8c6.8-24.3 18.3-36.7 34.9-37.5l4.3-.2.3 91.5c.1 52.8-.2 96.4-.7 103.1-1.5 18.1-4.8 23.6-15.6 26l-5.5 1.2V340h83v-11.8l-3.8-.7C103 326 98 320.6 96 310.1c-.6-3.4-1-41.7-1-104.9v-99.5l5.3.7c15.2 2.1 26 13.2 32.5 33.6 1.1 3.6 2.4 8 2.7 9.7.7 3.3.7 3.3 6.6 3.3h5.9V93H1v30.5zm1429.9 12.2c-9.6 17.7-18.5 27.8-31.4 35.9l-7.5 4.6V188h17.9l.3 64.2c.3 57.1.6 64.9 2.1 69.3 7.8 23.4 29.9 28.4 64.5 14.4 3.2-1.3 3.2-1.4 3.2-8.1V321l-3.2.8c-1.8.4-6.4.7-10.3.7-9.1 0-13.1-2.2-16.5-9l-2.5-5-.3-60.3-.3-60.2h31.1v-15h-31v-45h-11.8l-4.3 7.7zm48.6-6.7c-.4.6.8 1 2.9 1h3.6v8c0 10.3 1.8 10.5 2.2.2l.3-7.7 3.3-.3c1.7-.2 3.2-.7 3.2-1.3 0-1.2-14.7-1.2-15.5.1zm17.5 8c0 5.3.4 9 1 9s1-3.1 1-7.2c0-8.2.7-8.1 4.2.7 1.4 3.4 3 6 3.8 6 .8 0 2.6-2.8 4-6.2 1.5-3.5 2.9-6.6 3.3-7 .4-.3.7 2.6.7 6.5 0 4.1.4 7.2 1 7.2s1-3.7 1-9c0-8.2-.2-9-1.9-9-1.5 0-2.6 1.7-4.7 7-1.5 3.8-3 7-3.3 7-.3 0-1.9-3.2-3.5-7-2.1-5.2-3.3-7-4.7-7-1.7 0-1.9.9-1.9 9zM388.3 170c-28.2 5.1-48.8 30.4-54.8 67.4-2 12-1.9 34.1.1 44.6 3.5 18.8 9.8 31.4 21.5 43.1 8.2 8.3 17.4 13.6 28.4 16.4 7.9 2 24.9 2 32.9-.1 18.5-4.8 33.3-19.7 40.6-40.8l1.8-5.4-5.5-2.1c-3-1.2-6-2.1-6.6-2.1-.7.1-2.3 2.4-3.6 5.3-3.6 7.6-12.3 15.9-19.1 18.3-17.2 5.9-33.9-1.3-44.1-19.1-6-10.4-10.6-29.3-11.1-45.5l-.3-8.5 43.7-.3 43.7-.2-.5-5.3c-4.2-41.6-22.8-64.2-54.3-66.1-4.2-.3-9.9-.1-12.8.4zm13.6 16.4c5 2.6 9.9 9.1 12 15.9 1.6 5.3 4.1 19.1 4.1 22.8 0 .5-10.1.9-24.5.9H369l.6-4.3c3.6-24.6 11.6-36.5 24.7-36.7 2.6 0 6 .6 7.6 1.4zm799.4-16.4c-22.3 4-40.1 20.6-49.3 46-8.3 22.6-9.8 50.5-4 73.7 1.1 4.3 4.1 12 6.6 17.2 8.4 17.1 24.6 30.6 41.5 34.6 7.6 1.7 23.6 2 31.1.4 19.5-4.2 33.9-17.9 42.4-40.5l2.3-6.2-5.8-2.1c-3.2-1.1-6.2-2.1-6.7-2.1-.6 0-2.2 2.4-3.6 5.3-4 8-9.1 13.2-16.5 16.9-5.8 2.8-7.7 3.3-14.3 3.3-6.6 0-8.5-.5-14.2-3.3-12.1-5.9-20.7-18.5-25.4-37-2.6-10.3-5.1-30.9-4.1-33.5.6-1.6 4.5-1.7 43.7-1.7h43v-4.9c0-7-2.7-20.2-5.9-29.1-6.5-17.6-18.1-29.7-33.6-34.8-7.2-2.4-20-3.4-27.2-2.2zm13 16.4c4 1.6 8.4 6.6 10.8 12.3 2.2 5.3 4.9 17.9 4.9 23.3v4h-48v-2.4c0-4.3 2-13 4.6-20.2 2.8-7.9 8.1-14.9 12.8-17 4-1.7 10.8-1.8 14.9 0zm108.2-16c-8.7 1.7-13.4 3.7-20.5 8.7-13.5 9.5-20 24.9-18 42.5 1.4 12.2 5.6 20.2 14.8 28.5 2.7 2.4 13.8 10.6 24.6 18.3 10.9 7.6 22.2 16.2 25.1 19 11.6 11.4 13.3 23.2 4.7 32.8-5.1 5.7-10.1 7.8-18.8 7.8-13.4 0-21.5-6.6-30-24.5-2.3-5-4.8-10.9-5.5-13.3l-1.2-4.2H1286v45.7l5.8 3.1c9.9 5.3 19 7.4 35.2 7.9 16.7.6 23-.5 34.5-6.2 15.4-7.5 24.9-21.8 26.2-39.2 1.1-14.5-3.4-26.7-13.6-36.8-3.2-3.2-15-12.2-26.2-20.1-21.5-15.2-29.9-22.4-33.1-28.7-6.8-13.4.8-26.7 15.2-26.7 11.5 0 19.2 7 28.7 25.7l5.7 11.3h10.6v-42.1l-6.7-3c-14.1-6.5-32.6-9-45.8-6.5z"/></svg>
        <svg class="caret" viewBox="0 0 24 24">
        <path d="M15.729 12.576l-4.499 3.749c-0.488 0.407-1.23 0.060-1.23-0.576v-7.498c0-0.636 0.741-0.983 1.23-0.576l4.499 3.749c0.36 0.3 0.36 0.852 0 1.152z"></path>
        </svg>
      </a>
    </div>

    <div class="adopt">
      <div class="adopt-header">
        <h6>Thinking about adopting?</h6>
        <h2>These sweet pups in your area would love to join your pack.</h2>
      </div>
      
      <div class="adoptable-feed">

        <a class="dog-card" href="https://www.adoptapet.com/pet/31150280-vancouver-washington-husky" target="_blank">
          <img src="https://pet-uploads.adoptapet.com/1/c/b/547734775.jpg" />
          <h2>Dasher</h2>
          <p>Young male Husky/Greyhound mix in Vancouver, WA.</p>
        </a>

        <a class="dog-card" href="https://www.adoptapet.com/pet/31906252-portland-oregon-husky" target="_blank">
          <img src="https://pet-uploads.adoptapet.com/e/0/3/561028110.jpg" />
          <h2>Roon</h2>
          <p>Adult male Siberian Husky mix in Portland, OR.</p>
        </a>

        <a class="dog-card" href="https://www.adoptapet.com/pet/31854911-portland-oregon-husky" target="_blank">
          <img src="https://pet-uploads.adoptapet.com/5/5/7/559875486.jpg" />
          <h2>Navy Balto</h2>
          <p>Female Husky Mix puppy in Portland, OR.</p>
        </a>

        <a class="dog-card" href="https://www.adoptapet.com/pet/31917396-portland-oregon-husky" target="_blank">
          <img src="https://pet-uploads.adoptapet.com/1/b/d/561301986.jpg" />
          <h2>Maya Cloyd</h2>
          <p>Adult female Siberian Husky/Catahoula Leopard Dog Mix in Portland, OR.</p>
        </a>

        <a class="dog-card" href="https://www.adoptapet.com/pet/31221088-portland-oregon-husky" target="_blank">
          <img src="https://pet-uploads.adoptapet.com/9/1/8/550452159.jpg" />
          <h2>Piper</h2>
          <p>Adult female Husky in Portland, OR.</p>
        </a>

        <div class="adopt-card">
          <img src="https://images-ra.adoptapet.com/images/adoptapetlogo2017.svg" />
          <p>There are several more adoptable (and adorable) pups to see.</p>
          <a class="button" href="https://www.adoptapet.com/pet-search?clan_id=1&family_id=817&geo_range=50&location=Vancouver,%20WA&page=1" target="_blank">Search Dogs</a>
        </div>

      </div>
      
    </div>
</div>